import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords = [],
  canonical,
  ogType = 'website',
  ogImage,
  ogImageWidth,
  ogImageHeight,
  twitterCard = 'summary_large_image',
  noindex = false,
  structuredData
}) => {
  const siteName = 'TripTrot';
  const domain = 'https://dashboard.trip-trot.com';

  // Default meta description if not provided
  const metaDescription = description || 'Secure global package delivery platform connecting senders and travelers worldwide. Track packages, manage agreements, and ensure safe transport.';

  // Default keywords if not provided
  const metaKeywords = keywords.length > 0
    ? keywords
    : ['parcel delivery', 'package shipping', 'travel delivery', 'secure transport', 'global logistics', 'package tracking'];

  // Default Open Graph image
  const defaultOgImage = `${domain}/favicon.png`;

  // Generate canonical URL
  const canonicalUrl = canonical ? `${domain}${canonical}` : domain;

  // Generate title with site name
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Secure Global Package Delivery`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords.join(', ')} />
      <meta name="author" content={siteName} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph Tags */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImage || defaultOgImage} />
      {ogImageWidth && <meta property="og:image:width" content={ogImageWidth} />}
      {ogImageHeight && <meta property="og:image:height" content={ogImageHeight} />}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card Tags */}
      <meta property="twitter:card" content={twitterCard} />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={ogImage || defaultOgImage} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
